import Variation from '@material-ui/icons/BurstMode'
export const VariationsIcon = Variation
